import Vue from 'vue';

Vue.filter('timeFormat', require('./format').default);
Vue.filter('currencyFormat', require('./currency').default);
Vue.filter('conversionFormat', require('./conversion').default);
Vue.filter('htmlLineBreak', require('./html-line-break').default);
Vue.filter('isLocaleCurrency', require('./is-locale-currency').default);
Vue.filter('currencyToI18n', require('./currency-to-i18n').default);
